export var IdvError;
(function (IdvError) {
    IdvError["InvalidIdPhotoError"] = "InvalidIdPhotoError";
    IdvError["ExpiredIdError"] = "ExpiredIdError";
    IdvError["InvalidUserPhotoError"] = "InvalidUserPhotoError";
    IdvError["FaceMatchError"] = "FaceMatchError";
    IdvError["BarcodeMatchError"] = "BarcodeMatchError";
    IdvError["NameMatchError"] = "NameMatchError";
    IdvError["BirthDateMatchError"] = "BirthDateMatchError";
    IdvError["BarcodeDetectError"] = "BarcodeDetectError";
    IdvError["LivenessSkippedError"] = "LivenessSkippedError";
    IdvError["RestrictedIdDocumentError"] = "RestrictedIdDocumentError";
    IdvError["StableIdPatternError"] = "StableIdPatternError";
    IdvError["StableSelfiePatternError"] = "StableSelfiePatternError";
    IdvError["DocumentVoidedError"] = "DocumentVoidedError";
})(IdvError || (IdvError = {}));
export var DlvStatusMessage;
(function (DlvStatusMessage) {
    DlvStatusMessage["PENDING"] = "Pending";
    DlvStatusMessage["IN_PROGRESS"] = "In Progress";
    DlvStatusMessage["COMPLETED"] = "Completed";
    DlvStatusMessage["ERROR"] = "Error";
    DlvStatusMessage["NOT_APPLICABLE"] = "Not Applicable";
})(DlvStatusMessage || (DlvStatusMessage = {}));
export var DlvPipelineError;
(function (DlvPipelineError) {
    DlvPipelineError["UnsupportedLicenseType"] = "unsupported-license-type";
    DlvPipelineError["UnsupportedCountry"] = "unsupported-country";
    DlvPipelineError["MissingState"] = "missing-state";
    DlvPipelineError["MissingLicenseNumber"] = "missing-license-number";
    DlvPipelineError["IdentificationTypeUnsupportedByState"] = "identification-type-unsupported-by-state";
})(DlvPipelineError || (DlvPipelineError = {}));
export const captureTypeMap = {
    automatic: 'Automatic',
    manual: 'Manual',
    upload: 'Upload',
    digitalID: 'Digital ID'
};
// todo: Move
export var DocumentType;
(function (DocumentType) {
    DocumentType["AetnaInsurance"] = "aetna-insurance";
    DocumentType["CignaInsurance"] = "cigna-insurance";
    DocumentType["Citizen"] = "citizen";
    DocumentType["CommercialLicense"] = "commercial-license";
    DocumentType["CvsRx"] = "cvs-rx";
    DocumentType["DriversLicense"] = "drivers-license";
    DocumentType["DriversLicensePermit"] = "drivers-license-permit";
    DocumentType["Employment"] = "employment";
    DocumentType["GlobalEntry"] = "global-entry";
    DocumentType["Handgun"] = "handgun";
    DocumentType["HealthInsurance"] = "health-insurance";
    DocumentType["Identification"] = "identification";
    DocumentType["Indian"] = "indian";
    DocumentType["MatriculaConsular"] = "matricula-consular";
    DocumentType["Nexus"] = "nexus";
    DocumentType["Passport"] = "passport";
    DocumentType["PassportCard"] = "passport-card";
    DocumentType["Residence"] = "residence";
    DocumentType["UhcInsurance"] = "uhc-insurance";
    DocumentType["Visa"] = "visa";
    DocumentType["Other"] = "other";
})(DocumentType || (DocumentType = {}));
export const ID_PENALTY_KEYS = new Set([
    'id-card-detection',
    'id-paper-print',
    'id-distance-paper-print',
    'id-distance-faces-mismatch',
    'id-image-manipulation',
    'id-primary-face-detection',
    'id-e-screen',
    'id-distance-e-screen',
    'id-data-extraction',
    'id-primary-face-image-quality',
    'id-known-fraudulent-name',
    'id-public-persona',
    'id-primary-face-photo-injection',
    'id-information-missing',
    'id-field-manipulation',
    'id-primary-face-age-mismatch',
    'id-unsupported',
    'back-id-e-screen'
]);
export const SELFIE_PENALTY_KEYS = new Set([
    'selfie-e-screen',
    'selfie-distance-e-screen',
    'selfie-id-age-mismatch',
    'selfie-face-missing',
    'selfie-image-quality',
    'selfie-liveness-rejection',
    'selfie-public-persona',
    'selfie-distance-faces-mismatch',
    'selfie-standard-liveness-skipped',
    'selfie-enhanced-liveness-skipped',
    'selfie-enhanced-liveness-failed'
]);
export const ID_BARCODE_MISMATCH_KEYS = new Set([
    'id-barcode-mismatch'
]);
export const ID_NAME_MISMATCH_KEYS = new Set(['id-name-mismatch']);
export var JobImageType;
(function (JobImageType) {
    JobImageType[JobImageType["Selfie"] = 0] = "Selfie";
    JobImageType[JobImageType["IDFront"] = 1] = "IDFront";
    JobImageType[JobImageType["IDBack"] = 2] = "IDBack";
})(JobImageType || (JobImageType = {}));
